<!-- <h2 class="dialog-title">Save Overrides for {{ data.destinationName | titlecase }}?</h2>

<div class="dialog-body">
  <p>You are about to save feed override metadata for:</p>

  <div class="summary-box">
    <p><strong>Product:</strong> {{ data.productName }}</p>
    <p><strong>Destination:</strong> {{ data.destinationName }}</p>
  </div>

  <p>Do you want to continue?</p>
</div>

<div class="dialog-actions">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="continue()">Confirm</button>
</div>


 -->

<h2 mat-dialog-title>
  Save Overrides for {{ data.destinationName | titlecase }}?
</h2>

<div mat-dialog-content class="dialog-content">
  <p class="dialog-description">
    You are about to save feed override metadata for:
  </p>

  <div class="summary-box">
     <span class="label">Destination:  </span>
    <span class="value">{{ data.destinationName | titlecase }}</span>
  </div>

  <p>Do you want to continue?</p>

  <p class="dialog-warning">
    This will immediately affect future feed generations.
  </p>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="continue()">Confirm</button>
</div>
